import React, { Fragment } from "react";
import { Dropdown } from "react-bootstrap";
import TaskMemberAvatarPill from "./TaskMemberAvatarPill";
  
  // Tooltip reason for archived/moved assignees — same vocabulary as the Sync
  // Member Permissions chips (TAD-5797): Archived takes precedence over moved.
  export const unavailableReason = user => {
    if (!user?.Archived) return null;
    const memberType = user.IsGroup ? "Group" : "User";
    return user.Deleted ? `${memberType} is Archived` : "User/Group no longer in Department";
  };

  export const getPermissionMembers = (permission, permissionTaskMembers) => {
    const permissionMap = {
      editor: 'canEdit',
      viewer: 'canView',
      approver: 'canApprove',
      owner: 'isOwner'
    };
    return permissionTaskMembers.filter(p => p[permissionMap[permission]] === true);
  }

  export const filterAvailableMembers = (permissionMembers, assignedMembers) => {
    const available = assignedMembers.filter(member =>
      permissionMembers.some(p =>
        p.Id === member.Id && p.IsGroup === (member.IsGroup ?? false)
      )
    );

    // Archived/moved assignees are excluded from the assignable pool, so they
    // never match above. Fall back to the task member itself so the assignment
    // still renders (greyed) instead of silently disappearing (TAD-5898).
    const orphaned = permissionMembers
      .filter(p =>
        p.Archived && p.Member &&
        !available.some(member => member.Id === p.Id && (member.IsGroup ?? false) === p.IsGroup)
      )
      .map(p => p.Member);

    return [...available, ...orphaned];
  }

  export const initializeOwnerMembers = (assignedOwner) => {
    if (!assignedOwner) return [];
    if (Array.isArray(assignedOwner)) {
      return assignedOwner.map(owner => {
        return typeof owner === 'object' ? owner.Id : owner;
      }).filter(Boolean);
    }
    return typeof assignedOwner === 'object' ? [assignedOwner.Id] : [assignedOwner];
  };
  
  export const getIds = arr =>
    Array.isArray(arr) ? arr.map(o => (typeof o === "object" ? o.Id : o)).sort() : [];

  export const getUpdatedFilterMembersName = (concatMembers, filteredAssignedMembers) => {
    if (!Array.isArray(concatMembers)) return [];
    let updateFilterMembersName = [];
    let newFilteredNames = [];
    if (concatMembers) {
      concatMembers.map((member) => newFilteredNames.push(member.Name));
      updateFilterMembersName = filteredAssignedMembers?.filter(
        (name) => !newFilteredNames.includes(name)
      );
    }
    return updateFilterMembersName;
  };

  export const getGroupedUsers = (option, filteredSuggestions, filteredOwnerSuggestions, membersList, ownerMembers = []) => {
    let membersFromProject = filteredSuggestions.filter((suggestion) => {
      let member = membersList?.find((member) => member.Name === suggestion);
      return member?.IsProjectMember;
    });

    let membersFromDepartment = filteredSuggestions.filter((suggestion) => {
      let member = membersList?.find((member) => member.Name === suggestion);
      return member && !member.IsProjectMember;
    });
    //To be removed once we have groups as owners
    if(option === "owner"){
      membersFromProject = filteredOwnerSuggestions.filter((suggestion) => {
        let member = membersList?.find((member) => member.Name === suggestion && ownerMembers?.Name !== suggestion);
        return member?.IsProjectMember  && !member.IsGroup;
      });

      membersFromDepartment = filteredOwnerSuggestions.filter((suggestion) => {
        let member = membersList?.find((member) => member.Name === suggestion && ownerMembers?.Name !== suggestion);
        return member && !member.IsProjectMember && !member.IsGroup;
      });
    }

    return {
      membersFromProject,
      membersFromDepartment
    };
  };

  export const renderMemberSection = (
    members,
    label,
    permission,
    membersList,
    onClick,
    onKeyDown
  ) => {
    if (!members?.length) return null;
  
    return (
      <>
        <div className="dropdown-section-header p-2">{label}</div>
        {members.map((suggestion) => {
          const member = membersList.find((m) => m.Name === suggestion);
          return (
            <Fragment key={suggestion}>
              <Dropdown.Item
                onKeyDown={onKeyDown}
                className="dropdown-row"
                name={suggestion}
                onClick={(e) => onClick(suggestion, permission)}
                onMouseDown={(e) => e.preventDefault()}
                style={{ padding: "0.75rem 0.75rem 0.75rem 1rem" }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <TaskMemberAvatarPill user={member} permission={permission} size={24} />
                  <span>{suggestion}</span>
                </div>
              </Dropdown.Item>
            </Fragment>
          );
        })}
      </>
    );
  };
  
export const displayName = (member) => {
  if (!member?.Name) return '';
  return member.Name.length > 20 ? member.Name.slice(0, 20) + "..." : member.Name;
};